import { useEffect } from "react";
import { useDispatch } from "react-redux";

const useFetch = (status, fn) => {
    const dispatch = useDispatch();
    useEffect(() => {
        if(status === 'idle') dispatch(fn())
    }, [dispatch, status, fn])
}

export default useFetch;